import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },

  {
    path: '/pos-receipt',
    name: 'posreceipt',
    component: () => import('../components/modules/pos-receipt/Index.vue')
  },
  {
    path: '/satisfaction',
    name: 'satisfaction',
    component: () => import('../components/modules/satisfaction/Index.vue')
  },
  {
    path: '/thank-you',
    name: 'thankyou',
    component: () => import('../components/modules/satisfaction/Thankyou.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
